export default __webpack_public_path__ + "static/media/followHeader.3e52b311.svg";